export const mockScanStats = {
  total: 48320,
  today: 1247,
  thisWeek: 8934,
  uniqueUsers: 31205,
  totalChange: 12.4,
  todayChange: 8.7,
  weekChange: -3.2,
  uniqueChange: 15.1,
};

export const mockDailyScans = [
  { date: "20 Nis", scans: 1120 },
  { date: "21 Nis", scans: 980 },
  { date: "22 Nis", scans: 1340 },
  { date: "23 Nis", scans: 1560 },
  { date: "24 Nis", scans: 1200 },
  { date: "25 Nis", scans: 1780 },
  { date: "26 Nis", scans: 1247 },
];

export const mockCountryStats = [
  { country: "Türkiye", flag: "🇹🇷", scans: 18420, percent: 38 },
  { country: "Almanya", flag: "🇩🇪", scans: 9640, percent: 20 },
  { country: "ABD", flag: "🇺🇸", scans: 7250, percent: 15 },
  { country: "Fransa", flag: "🇫🇷", scans: 4830, percent: 10 },
  { country: "İngiltere", flag: "🇬🇧", scans: 3860, percent: 8 },
];

export const mockDeviceStats = [
  { device: "iOS", percent: 44, color: "#10b981" },
  { device: "Android", percent: 38, color: "#34d399" },
  { device: "Desktop", percent: 18, color: "#6ee7b7" },
];

export const mockRecentScans = [
  { id: 1, date: "27 Nis 2026", time: "14:32", country: "🇹🇷 Türkiye", city: "İstanbul", device: "iPhone 15", browser: "Safari", ip: "185.x.x.x" },
  { id: 2, date: "27 Nis 2026", time: "14:28", country: "🇩🇪 Almanya", city: "Berlin", device: "Samsung S24", browser: "Chrome", ip: "91.x.x.x" },
  { id: 3, date: "27 Nis 2026", time: "14:15", country: "🇺🇸 ABD", city: "New York", device: "MacBook Pro", browser: "Firefox", ip: "72.x.x.x" },
  { id: 4, date: "27 Nis 2026", time: "13:58", country: "🇫🇷 Fransa", city: "Paris", device: "Pixel 8", browser: "Chrome", ip: "212.x.x.x" },
  { id: 5, date: "27 Nis 2026", time: "13:44", country: "🇬🇧 İngiltere", city: "Londra", device: "iPhone 14", browser: "Safari", ip: "86.x.x.x" },
  { id: 6, date: "27 Nis 2026", time: "13:30", country: "🇹🇷 Türkiye", city: "Ankara", device: "Xiaomi 13", browser: "Chrome", ip: "78.x.x.x" },
  { id: 7, date: "27 Nis 2026", time: "13:12", country: "🇩🇪 Almanya", city: "Münih", device: "iPad Pro", browser: "Safari", ip: "93.x.x.x" },
  { id: 8, date: "27 Nis 2026", time: "12:55", country: "🇺🇸 ABD", city: "Los Angeles", device: "Windows PC", browser: "Edge", ip: "104.x.x.x" },
];
